import { get, isEmpty, noop } from 'lodash';
import PropTypes from 'prop-types';

import PadModeSelect from '~/components/PadModeSelect';
import { COMPLETION_APP_TYPES } from '~/constants/completion';
import { getAssetKey, getDefaultPadModeSetting } from '~/utils/completion';

const PadMode = ({
  fracFleet,
  wells,
  well,
  onSettingChange,
  appSettings,
  completionAppType,
  disableActiveWellsInPadSelect,
  enableSimulFracInPadSelect,
}) => {
  if (well || isEmpty(wells) || !fracFleet) return null;

  // use COMPLETION_APP_TYPES.fracMultiWellApp as a default if not defined in app;
  // this will be moved to the Apps Wizard soon
  // https://corvaqa.atlassian.net/browse/DC-1317

  const { padId } = appSettings;

  const appType = completionAppType || COMPLETION_APP_TYPES.fracMultiWellApp;
  const assetKey = getAssetKey(fracFleet, well, padId);
  const currentPadModeSetting = get(appSettings, ['settingsByAsset', assetKey]);

  const padModeSetting = !isEmpty(currentPadModeSetting)
    ? currentPadModeSetting
    : getDefaultPadModeSetting(fracFleet, well, appType, enableSimulFracInPadSelect, padId);

  const lines =
    fracFleet.pad_frac_fleets.find(padFracFleet =>
      padId ? +padFracFleet.pad.id === +padId : padFracFleet.current
    )?.frac_fleet_lines || [];

  return (
    <PadModeSelect
      assets={wells}
      completionAppType={appType}
      disableActiveWellsInPadSelect={disableActiveWellsInPadSelect}
      enableSimulFracInPadSelect={enableSimulFracInPadSelect}
      padModeSetting={padModeSetting}
      fracFleetLines={lines}
      onChange={newPadModeSetting =>
        onSettingChange('settingsByAsset', {
          ...get(appSettings, 'settingsByAsset', {}),
          [assetKey]: newPadModeSetting,
        })
      }
    />
  );
};

PadMode.propTypes = {
  appSettings: PropTypes.shape({
    padId: PropTypes.number,
  }),
  completionAppType: PropTypes.string,
  fracFleet: PropTypes.shape({}),
  onSettingChange: PropTypes.func,
  well: PropTypes.shape({}),
  wells: PropTypes.arrayOf(PropTypes.shape()),
  disableActiveWellsInPadSelect: PropTypes.bool,
  enableSimulFracInPadSelect: PropTypes.bool,
};

PadMode.defaultProps = {
  appSettings: {},
  completionAppType: undefined,
  fracFleet: undefined,
  onSettingChange: noop,
  well: undefined,
  wells: undefined,
  disableActiveWellsInPadSelect: false,
  enableSimulFracInPadSelect: false,
};

export default PadMode;
